import * as Lucide from "lucide-react";

/** Render a lucide icon by name string. */
export function Icon({ name, className = "", strokeWidth = 1.6, ...rest }) {
  const Cmp = Lucide[name] || Lucide.Square;
  return <Cmp className={className} strokeWidth={strokeWidth} {...rest} />;
}
